import { mapGetters } from "vuex";
export default {
  data() {
    return {
      myrules: {
        required: (value) => !!value || "Required.",
        email: (value) => /.+@.+\..+/.test(value) || "Must be Email",
        alphanumeric: (value) =>
          /^[a-z0-9]+$/i.test(value) || "Only aphanumeric values allowed",
        spaces: (value) =>
          (value || "").indexOf(" ") < 0 || "No spaces are allowed",
      },
    };
  },
  computed: {
    ...mapGetters([
      "statuses",
      "marketSegments",
      "mapsLoader",
      "opportunityCards",
	  "opportunityLoader",
    "opportunityStages",
    "contractTypes",
    "externalContacts",
    ]),
  },
};
